/**
 * Copyright Fitzba Technologies Inc. 2023
 *
 * A list of item cards
 *
 * @author Yang Ming
 * @version May 09, 2023
 */
import React, { useState } from 'react'
import ItemCard from './ItemCard'
import ServiceCard from './ServiceCard'
import ItemCardMobile from './ItemCardMobile'
import { useSelector, useDispatch } from 'react-redux'
import ShoppingCartHook from '@hooks/ShoppingCart.hook'
import ResultHeader from './ResultHeader'
import ServiceEmpty from './ServiceEmpty'
import SearchSeemore from './SearchSeemore'
import {
  setFilterSortBy,
  SORTBY_CODE,
  setFilterCondition
} from '@reducers/contentReducer'
import LoadingSection from '@components/LoadingSection'
import './ItemListNew.css'

export default function ServiceList({
  isShowFilterDetail,
  isMobile,
  servicesList,
  isLoading,
  searchParams,
  onClickSeeMore,
  seeMoreRef
}) {
  const dispatch = useDispatch()
  const { addToCart } = ShoppingCartHook()
  const itemsFilter = useSelector(state => state.content.itemsFilter)
  const userinfo = useSelector(state => state.user.userinfo)
  // Handle sorting filter change
  const onClickSortBy = e => {
    dispatch(setFilterSortBy(Number(e.target.value)))
  }

  const keywordsList = itemsFilter?.title?.split(' ') || []

  if (isLoading)
    return <LoadingSection text='Loading Services' />

  return (

    <div className='items-content'>
      {/* <ResultHeader
        onClickSortBy={onClickSortBy}
        itemsFilter={itemsFilter}
        itemsList={itemsList}
        SORTBY_CODE={SORTBY_CODE}
        userinfo={userinfo}
        isGrid={isGrid}
        setIsGrid={setIsGrid}
        isMobile={isMobile}
      />
      */}
      {(servicesList?.total === 0) &&
        <ServiceEmpty keywords={itemsFilter.title} />
      }
      {servicesList?.total > 0 && (
        <>
          <section className="w-full px-5 m-auto flex flex-col" id='service-list'>
            <div className="w-full h-auto flex gap-10 text-left smsize:gap-3 flex-wrap">
              {servicesList?.data?.map((service, index) => (
                <ServiceCard
                  key={index}
                  service={service}
                  userinfo={userinfo}
                  handleAddToCart={addToCart}
                  keywordsList={keywordsList}
                  searchParams={searchParams}
                />
              ))}
            </div>
          </section>
          {servicesList?.totalPage > itemsFilter.currentPage &&
            <SearchSeemore onClickSeeMore={onClickSeeMore} isMobile={isMobile} seeMoreRef={seeMoreRef} />
          }
        </>
      )}
    </div>
  )
}
